module.exports = __webpack_public_path__ + "static/media/blog-padvish.629b86c4.jpg";